import { getApiClient, initializeApiClient } from "../../apiService";

const UpdateGenderMainstreaming = async (
  tG_MainTargetedGroupId,
  genderInclusionPlan,
  aI_ApplicationInformationId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TG_MainTargetedGroup/UpdateTG_MainTargetedGroupData`,
    {
      tG_MainTargetedGroupId: tG_MainTargetedGroupId,
      genderInclusionPlan: genderInclusionPlan,

      aI_ApplicationInformationId: aI_ApplicationInformationId,
    }
  );

  return response.data.result;
};

export default UpdateGenderMainstreaming;
